import { DataGridPremium } from '@mui/x-data-grid-premium';
import { deDE } from '@mui/x-data-grid/locales';
import { get } from 'lodash';
import React, { FC, useMemo } from 'react';
import { useApplication } from '../../../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../../../lib/constants/constant';
import { DisplayEuroMUI } from '../../../../../../../../utils/formats';
import { enumT } from '../../../../../../../../utils/helper';
import ApplicationHeading from '../../../../../application-heading/ApplicationHeading';

// import schemas
import { Box } from '@mui/material';
import { getUnternehmenDisplayName } from 'src/utils/ausgabenFinanzierungHelper';
import Schema from '../../../../../../../../lib/paths/antrag_FULL_Paths.json';
import kostenPositionSchema from '../../../../../../../../lib/paths/kostenposition_FULL_Paths.json';
const P = Schema.attributes;
const KP_P = kostenPositionSchema.attributes;

const EinnahmeUebersichtSkizzeLoewe: FC<{}> = () => {
	const { application } = useApplication();

	const columns = [
		// { field: 'id', headerName: 'ID', width: 80 },
		// { field: 'kostentraeger', headerName: 'Kostenträger', flex: 1 },
		{ field: 'unternehmen', headerName: 'Organisation', width: 180 },
		{ field: 'kostenkategorie', headerName: 'Kategorie', flex: 1 },
		{ field: 'bezeichnung', headerName: 'Bezeichnung', flex: 1 },
		{
			field: 'gesamtSumme',
			headerName: 'Geplante Gesamtsumme (€)',
			flex: 1,
			type: 'number' as const,
			valueFormatter: (value: any) => {
				return value ? DisplayEuroMUI(value) : 0;
			},
		},
	];

	const rows = useMemo(() => {
		let row = get(application, P.Foerderantrag_Kostenpositions.path, [])
			.filter((ele: any) => get(ele, KP_P.Allgemein_Kostenposition.path) === 'Einnahme')
			.map((ele: any) => {
				return {
					id: get(ele, 'id'),
					kostentraeger: get(ele, KP_P.Allgemein_Kostentraeger.path, ''),
					unternehmen: getUnternehmenDisplayName(application, ele),
					bezeichnung: get(ele, KP_P.Allgemein_Bezeichnung.path),
					kosterart: enumT(get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path, '')),
					kostenkategorie: get(ele, KP_P.Allgemein_Kostenkategorie.schema.attributes.Allgemein_Bezeichnung.path),
					gesamtSumme: get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path),
				};
			});
		return row;
	}, [application]);

	const initialState: any = useMemo(() => {
		const projectStartYear = get(application, P.Allgemein_Projektstart_Jahr.path);
		const projectDurationYears = get(application, P.Allgemein_Projektdauerin_Jahren.path);

		const model: any = Array.from({ length: projectDurationYears }).reduce((acc: any, _, i) => {
			acc[projectStartYear + i] = 'sum';
			return acc;
		}, {});

		return {
			aggregation: {
				model: {
					...model,
					gesamtSumme: 'sum',
				},
			},
			columns: {
				columnVisibilityModel: {
					// Hide the column used for leaves
					unternehmen: false,
				},
			},
			rowGrouping: {
				model: ['unternehmen'],
			},
			sorting: {
				sortModel: [
					{
						field: 'kostenkategorie',
						sort: 'asc', // oder 'desc' für absteigende Sortierung
					},
				],
			},
		};
	}, [application]);

	return (
		<>
			<ApplicationHeading title='Eigen- und Drittmittel Übersicht' description={PLATZHALTER_TEXT} />
			<Box sx={{ height: 'auto' }}>
				<DataGridPremium
					rows={rows}
					columns={columns}
					initialState={initialState}
					groupingColDef={{
						headerName: 'Organisation',
						valueFormatter: (value: any) => value ?? 'Gesamt',
					}}
					hideFooter
					defaultGroupingExpansionDepth={-1}
					localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
				/>
			</Box>
		</>
	);
};

export default EinnahmeUebersichtSkizzeLoewe;
